export default "__VITE_ASSET__BtMDqEPj__"